import React from 'react'
import HypButtonGroup from './HypButtonGroup'
import { Button, Tooltip } from '@material-ui/core'
import { getPrefixLang } from '../../app/selectors/lang'
import { useActiveFilterFlags } from '../hooks/useActiveFilterFlags'
import useToggleFlagsHandler from '../hooks/useToggleFlagsHandler'

/**
 * Displays a button group of age group filters that can be
 * toggled on and off.
 */
const SedaFlagGroup = ({ flags, tooltip, ...props }) => {
  // currently active filter flags
  const activeFlags = useActiveFilterFlags(flags)
  // function that sets filter state on changes
  const setFilterFlags = useToggleFlagsHandler(flags)
  // handler that sets the corresponding filters and clicked values
  const handleChange = value => {
    value[0] === 'all'
      ? setFilterFlags(flags)
      : setFilterFlags(value)
  }

  const buttons = flags.map(flag => {
    const tooltipText = getPrefixLang(flag, 'TOOLTIP_HINT')
    const hasTooltip = Boolean(tooltipText)
    return (
      <Button key={flag} value={flag}>
        {hasTooltip && (
          <Tooltip title={tooltipText}>
            <span>{getPrefixLang(flag, 'FLAG_LABEL')}</span>
          </Tooltip>
        )}
        {!hasTooltip && getPrefixLang(flag, 'FLAG_LABEL')}
      </Button>
    )
  })

  const buttonGroup = (
    <HypButtonGroup
      active={activeFlags.length === 0 ? 'all' : activeFlags}
      onChange={handleChange}
      toggleAll
      {...props}>
      {[
        ...buttons,
        <Button key={'all'} value={'all'}>
          ALL
        </Button>
      ]}
    </HypButtonGroup>
  )

  if (!tooltip) return buttonGroup
  return (
    <Tooltip title={tooltip} placement="top" arrow>
      {buttonGroup}
    </Tooltip>
  )
}

export default SedaFlagGroup
